import { checkPagePermission, getOperatorInfo } from '../services/app';

export default {
  namespace: 'privileges',
  state: {
    element: {},
    userInfo: {},
    currentOperatorData: {},
  },

  effects: {
    * fetchPagePermit ({ payload }, { call, put }) {
      const response = yield call(checkPagePermission, payload);
      if (response.success) {
        yield put({
          type: 'pagePermit',
          payload: {
            key: payload.pageId,
            response: response.result,
          },
        });
      }
    },
    * setElement ({ pageId }, { call, put }) {
      const response = yield call(checkPagePermission, { pageId });
      yield put({
        type: 'element',
        payload: response.result,
      });
    },
    * fetchOperatorInfo ({ payload }, { call, put }) {
      const response = yield call(getOperatorInfo, payload);
      if (response.success) {
        yield put({
          type: 'update',
          payload: {
            currentOperatorData: response.result,
          },
        });
      }
    },
  },

  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    pagePermit (state, action) {
      return {
        ...state,
        [`${action.payload.key}`]: action.payload.response,
      };
    },
    element (state, action) {
      return {
        ...state,
        element: action.payload,
      };
    },
  },
};
